import { Injectable } from 'injection-js';

@Injectable()
export class Forms {
  public static toggleDisable(field: JQuery, state: boolean): void {
    field.prop('disabled', state);
  }
}
